import React from 'react'
import { useTranslation } from 'react-i18next'

const ErrorHandler = () => {
  const { t } = useTranslation()
  return <div className="error">{t('errors.went_wrong')}</div>
}

export default ErrorHandler
